var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChromePicker',{staticClass:"vuestic-advanced-picker",model:{value:(_vm.valueProxy),callback:function ($$v) {_vm.valueProxy=$$v},expression:"valueProxy"}})
}
var staticRenderFns = []

export { render, staticRenderFns }